import DatePicker from "react-datepicker";
import dateFormatter from "../../services/utils/helpers/dateFormatter";
import MaskedInput from "react-text-mask";
import moment from "moment";
import CalendarIcon from "../../assets/svg/Calendar";
import CustomSelect from "../organism/CustomSelect";
import { createPortal } from "react-dom";

function CustomDatePicker({
  value,
  disabled,
  showError,
  handleDate,
  setFieldValue,
  fieldName,
  testOrderTable,
  UMSeqDateOfCollection,
  ...props
}: any) {
  const renderCustomHeader = ({ date, changeYear, changeMonth }: any) => {
    // Check if maxDate is today
    const isMaxDateToday =
      props.maxDate && moment(props.maxDate).isSame(moment(), "day");

    // Get the current year and month
    const currentYear = moment().year();
    const currentMonth = moment().month();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    // Filter months if maxDate is today
    let filteredMonths;
    if (UMSeqDateOfCollection) {
      filteredMonths = months;
    } else if (isMaxDateToday && date.getFullYear() === currentYear) {
      filteredMonths = months.slice(0, currentMonth + 1);
    } else {
      filteredMonths = months;
    }

    const years = UMSeqDateOfCollection
      ? Array.from({ length: 36 }, (_, i) => currentYear - 25 + i) // 25 years before, 10 years after
      : Array.from({ length: 100 }, (_, i) => currentYear - i);

    const monthOptions: any = filteredMonths.map((month) => ({
      label: month,
      value: month,
    }));
    const yearOptions: any = years.map((year) => ({
      label: year.toString(),
      value: year,
    }));

    return (
      <div className="flex justify-center px-3">
        <CustomSelect
          options={monthOptions}
          selected={monthOptions.find(
            (option: any) => option.value === months[date.getMonth()]
          )}
          setSelected={(option: any) =>
            changeMonth(months.indexOf(option.value))
          }
        />
        <CustomSelect
          options={yearOptions}
          selected={yearOptions.find(
            (option: any) => option.value === date.getFullYear()
          )}
          setSelected={(option) => changeYear(option.value)}
        />
      </div>
    );
  };

  // Calculate maxDate for future years when UMSeqDateOfCollection is true
  let customMaxDate = null;
  if (UMSeqDateOfCollection) {
    const lastYear = moment().year() + 10;
    customMaxDate = new Date(lastYear, 11, 31); // December 31st of last year
  }

  return (
    <DatePicker
      selected={!!value ? dateFormatter(value) : null}
      renderCustomHeader={renderCustomHeader}
      placeholderText={testOrderTable ? "Creation Date" : "MM-DD-YYYY"}
      scrollableYearDropdown
      showYearDropdown
      popperContainer={({ children }) => {
  const portalRoot = document.getElementById('datepicker-portal');
  return createPortal(children, portalRoot || document.body);
}}
      maxDate={UMSeqDateOfCollection ? customMaxDate : props.maxDate}
      showIcon
      icon={
        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none z-[1]">
          <CalendarIcon />
        </span>
      }
      customInput={
        <MaskedInput
          type="text"
          mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
        />
      }
      disabled={disabled}
      yearDropdownItemNumber={100}
      dateFormat={"MM-dd-yyyy"}
      className={`w-full ${testOrderTable && "hover:border hover:border-[#172B4D]"
        } focus:ring-transparent roundedTextInput text-xs sm:text-base ${props.className} ${disabled && "cursor-not-allowed"
        } ${value ? "text-royalBlue" : "text-borderGray"} ${showError ? "border-requiredRed focus:border-requiredRed" : ""
        } pr-8 md:pr-8`}
      onChange={
        !!handleDate
          ? handleDate
          : (date: any) => {
            if (date === null) {
              setFieldValue?.(fieldName, "");
            } else {
              setFieldValue?.(fieldName, moment(date).format("MM-DD-YYYY"));
            }
          }
      }
    />
  );
}
export default CustomDatePicker;
